/* AYO cart drawer extras: "Complete the look" loading and one-tap add, WhatsApp click tracking.
   The core cart behavior (quantity, remove, discount, re-render) stays in the theme's cart.js / cart-drawer.js. */
(function () {
  const cache = new Map();

  async function fetchUpsell(box) {
    const id = box.dataset.productId;
    const base = box.dataset.url || '/recommendations/products';
    const exclude = box.dataset.exclude || ',';
    const key = `${id}|${exclude}`;
    if (cache.has(key)) return cache.get(key);
    let failed = false;
    const get = async (intent) => {
      const res = await fetch(`${base}?product_id=${encodeURIComponent(id)}&limit=8&intent=${intent}&section_id=ayo-cart-upsell`);
      if (!res.ok) { failed = true; return ''; }
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const cards = doc.querySelector('.ayo-cart__upsell-cards');
      return cards && cards.children.length ? cards.innerHTML : '';
    };
    let html = '';
    try {
      html = await get('complementary');
      if (!html) html = await get('related');
    } catch (e) {
      failed = true;
      html = '';
    }
    if (!failed) cache.set(key, html);
    return html;
  }

  async function loadUpsell(root) {
    const box = (root || document).querySelector('[data-ayo-upsell]:not([data-loaded])');
    if (!box) return;
    box.setAttribute('data-loaded', '');
    const html = await fetchUpsell(box);
    const list = box.querySelector('[data-ayo-upsell-list]');
    if (!html || !list || !box.isConnected) return;
    list.innerHTML = html;
    box.hidden = false;
  }

  function watchDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    // load "Complete the look" only once the drawer is actually open, not on every page view
    const maybeLoad = () => { if (drawer.classList.contains('active')) loadUpsell(drawer); };
    maybeLoad();
    new MutationObserver(maybeLoad).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  async function addUpsell(btn) {
    const cart = document.querySelector('cart-drawer');
    if (!cart || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    const fd = new FormData();
    fd.append('id', btn.dataset.variantId);
    fd.append('quantity', '1');
    fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
    fd.append('sections_url', window.location.pathname);
    try {
      const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      });
      const data = await res.json();
      if (data.status) { btn.classList.remove('is-loading'); btn.classList.add('is-error'); return; }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ayo-cart-upsell', productVariantId: btn.dataset.variantId, cartData: data });
      }
      cart.renderContents(data);
    } catch (e) {
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
    }
  }

  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-ayo-up-add]');
    if (add) { e.preventDefault(); addUpsell(add); return; }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();
})();
